export default __webpack_public_path__ + "pizza.svg";